export default {
  memberCommand: {
    "services": "Servizi",
    "diagnostics": "Diagnostica degli sviluppatori",
    "placeholder": "Trova una pagina o un'azione...",
    "club": "Il tuo CLUB",
    "quick": "QUICK AZIONI",
    "current": "Attuale",
    "navigate": "Navigare",
    "open": "Apri",
    "close": "Chiudi",
    "empty": "Nessuna pagina o azione corrispondente. Prova un'altra ricerca.",
    "clear": "Cancella la ricerca",
    "label": "Navigazione dei soci",
    "results": "{count} risultati disponibili",
    "bookings": "Le mie prenotazioni",
    "account": "Il mio account",
    "other": "Portale dei soci",
    "dashboard": "Il tuo club a colpo d'occhio",
    "book-facilities": "Golf, racchette, pranzo e altro ancora",
    "activities": "Scopri i modi per godersi il tuo club",
    "academy": "Camp, programmi e workshop",
    "events": "Cosa c'è nel tuo club",
    "reciprocal-clubs": "Esplora la tua rete reciproca",
    "accommodations": "Trova e prenota il tuo prossimo soggiorno",
    "manage": "Gestisci le tue attività",
    "voting": "Visualizzare le mozioni del club e votare",
    "dashboardKeywords": "home panoramica",
    "book-facilitiesKeywords": "prenotazioni sport ristorante corti",
    "activitiesKeywords": "club hobby",
    "academyKeywords": "corsi di apprendimento",
    "eventsKeywords": "biglietti per il calendario",
    "reciprocal-clubsKeywords": "partner accesso ai viaggi",
    "accommodationsKeywords": "hotel camere soggiorni",
    "manageKeywords": "attività di amministrazione",
    "votingKeywords": "mozioni schede"
},
  member_all_handicaps: "Tutti gli handicap",
  member_handicap_or_better: "Handicap {value} o meglio",
  member_handicap_or_worse: "Handicap {value} o peggio",

  member_leave: "Lascia perdere.",
  member_unable_to_leave_this_open_group_right_now: "Incapace di lasciare questo gruppo aperto in questo momento.",
  member_leave_group_confirm: "Lascia questo gruppo aperto?",
  member_hosts_manage_booking: "Gestisci la tua prenotazione dalle prossime prenotazioni.",
  member_loading_open_groups: "Caricamento di gruppi aperti...",
  member_open_groups: "Gruppi aperti",
  member_open_group_help: "Invita altri soci a riempire i luoghi che scegli. La tua prenotazione rimane privata a meno che non selezioni gruppo aperto.",
  member_level_not_provided: "Livello non fornito",
  member_level_metric: "Livello",
  member_handicap_metric: "Handicappati",
  member_all_levels: "Tutti i livelli",
  member_level_preferences: "Intervallo di livello preferito",
  member_level_preferences_help: "Facoltativo · scala del profilo 1–5. Lasciare entrambi vuoti per tutti i livelli. Questa e' una preferenza.",
  member_minimum_level: "Livello minimo",
  member_maximum_level: "Livello massimo",
  member_open_groups_load_failed: "Incapace di caricare i gruppi aperti.",
  member_open_group_details_failed: "Non è possibile caricare i dettagli del gruppo.",

  member_events_retry: "Riprova",
  "member_events_heading": "Eventi",
  "member_event_count_one": "{count} evento",
  "member_event_count_other": "{count} eventi",
  "at_risk": "A rischio",
  "super_engaged": "Super impegnato",
  "proactive_exposure_recovery_opportunities": "Opportunità di esposizione proattiva e di recupero",
  "outstanding": "Insoluto",
  "cancellations": "Cancellazioni",
  "disengagement": "Disimpegno",
  "membership_spend_ytd": "Spese di iscrizione · YTD",
  "total_members": "Totale soci",
  "new_members": "Nuovi soci",
  "this_month": "Questo mese",
  "amount_due": "Importo dovuto",
  "member_accounts": "Conti nazionali",
  "find_a_member": "Trova un socio",
  "search_members": "soci della ricerca",
  "hidden_patterns_across_your_club": "Modelli nascosti nel tuo club",
  "no_current_intelligence_items": "Nessun elemento di intelligenza attuale.",
  "no_upcoming_birthdays": "Nessun compleanno imminente",
  "nothing_in_the_current_period": "Nulla nel periodo attuale",
  "club_conditions_and_forecast": "Condizioni Club e previsioni",
  "view_current_conditions": "Visualizza le condizioni attuali",
  "open_the_live_club_forecast": "Aprire le previsioni del club dal vivo",
  "unable_to_load_this_dashboard_data_right_now": "Non è possibile caricare questi dati del cruscotto in questo momento.",
  "loading_exposure_detail": "Caricamento dell'esposizione...",
  "outstanding_balances": "Bilanci eccezionali",
  "cancellations_refunds": "Cancellazioni e rimborsi",
  "disengagement_exposure": "Disattivazione dell'esposizione",
  "total_exposure": "Esposizione totale",
  "record": "Registrazione",
  "no_records_in_this_category": "Nessun record in questa categoria.",
  "loading_metrics": "Metriche di carico...",
  "unable_to_load_leadership_metrics": "Incapace di caricare metriche di leadership.",
  "executive_snapshot_year_to_date": "Istantanea esecutiva · Anno alla data",
  "membership_spend": "Spese di iscrizione",
  "net_movement_this_month": "Movimento netto questo mese",
  "member_account_exposure": "Esposizione dei conti soci",
  "membership_health": "Sanità degli Stati soci",
  "revenue_exposure_composition": "Composizione dell'esposizione alle entrate",
  "needs_attention": "Necessità di attenzione",
  "outstanding_member_account_balances_require_review": "Le bilance dei conti dei soci eccezionali richiedono una revisione.",
  "loading_intelligence": "Caricamento dell'intelligenza...",
  "dashboard_details": "Dettagli di Dashboard",
  "favourites": "Preferiti",
  "new_chat": "Nuova chat",
  "collapse_panel": "Pannello di errore",
  "show_history": "Mostra la storia",
  "loading_conversation": "Caricamento della conversazione...",
  "conversation_could_not_be_restored": "Conversazione non può essere ripristinata",
  "retry_loading": "Carico di rinforzo",
  "how_can_i_help_you_manage_the_club_today": "Come posso aiutarla a gestire il club oggi?",
  "external_sources": "Fonti esterne",
  "sources": "Fonti",
  "prepare_again": "Preparare di nuovo",
  "sms_option": "SMS Opzione",
  "no_message_preview_available": "Non è disponibile l'anteprima del messaggio.",
  "sent": "Inviato",
  "member_option": "Opzione dei soci",
  "select": "Seleziona",
  "review_proposed_action": "Commento proposto ricorso",
  "review_draft": "Progetto di revisione",
  "review_action": "Recensione Azione",
  "staff_member": "Membro del personale",
  "email_draft": "Progetto e-mail",
  "select_one_of_your_mailboxes": "Seleziona una delle tue caselle di posta",
  "connect_your_mailbox_to_prepare_mailbox_backed_drafts_later": "Collegare la casella di posta per preparare bozze di posta-backed più tardi",
  "recipients": "Recipienti",
  "no_recipients_selected_editable_unsent_draft": "Nessun destinatario selezionato · bozza modificabile, invio",
  "recipient_contact_details_need_attention_this_draft_remains_saved_and_unsent": "I dettagli di contatto importanti hanno bisogno di attenzione. Questa bozza rimane salvata e non inviata.",
  "recipients_individual_emails": "destinatari · singole e-mail",
  "missing_email": "email mancante",
  "subject": "Oggetto",
  "email_subject": "Oggetto dell'email",
  "email_cc": "E-mail CC",
  "email_bcc": "E-mail in Ccn",
  "sender_mailbox": "Cassetta di sicurezza",
  "server_selected_mailbox": "casella di posta selezionata dal server",
  "email_body": "E-mail corpo",
  "preview_personalised_email": "Anteprima email personalizzata",
  "first_name_is_personalised_for_each_recipient": "Il primo nome è personalizzato per ogni destinatario.",
  "preview_recipient": "Anteprima del destinatario",
  "previewing_as": "Anteprima come",
  "recipient": "destinatario",
  "your_saved_signature": "La firma salvata",
  "connect_mailbox": "Collegare la casella postale",
  "discard": "Cartolina",
  "reload_draft": "Ricarica bozza",
  "action_failed": "Azione fallita",
  "an_unknown_error_occurred": "Si è verificato un errore sconosciuto.",
  "golf_outing_created": "Golf Outing Creato!",
  "view_in_events": "Visualizza in Eventi",
  "view_tee_sheet": "Visualizza foglio Tee",
  "action_successful": "Azione Successo",
  "stopping": "Fermare...",
  "preparing_your_answer": "Preparare la tua risposta.",
  "confirm_send": "Conferma Invia Invia",
  "target": "Obiettivo:",
  "confirming": "Conferma in corso…",
  "privana_assist_is_working": "Privana Assist sta lavorando...",
  "answer_now_becomes_available_after_verified_work_completes": "La risposta ora diventa disponibile dopo il completamento del lavoro verificato.",
  "answer_now": "Rispondi ora",
  "unable_to_continue": "Incapace di continuare",
  "completed_evidence_and_outputs_were_retained": "Sono state conservate prove e uscite complete.",
  "completed_verified_work_was_retained_you_can_retry_when_the_reported_constraint_is_resolved": "Completato il lavoro verificato è stato mantenuto. È possibile riprovare quando il vincolo segnalato è risolto.",
  "jump_to_latest": "Vai all'ultimo",
  "retry_loading_this_conversation_before_sending": "Ripristina a caricare questa conversazione prima di inviare.",
  "finish_cancel_or_answer_the_current_request_before_starting_another": "Terminare, annullare o rispondere alla richiesta corrente prima di iniziare un altro.",
  "ask_privana_e_g_add_a_new_member_named_john_smith": "Chiedi a Privana... (ad esempio, 'add a new member name John Smith')",
  "send_message": "Invia messaggio",
  "conversation_loading_failed_retry_is_required_before_you_can_send": "Il carico di conversazione è fallito. L'esame è richiesto prima di poter inviare.",
  "explore": "Esplorare",
  "shift_enter_for_newline": "Shift+Enter per la nuova linea",
  "edit_sms_option": "Modifica SMS (opzione",
  "upcomingOne": "{count} prossimo compleanno",
  "upcomingMany": "{count} prossimi compleanni",
  "inDaysOne": "Tra {count} giorno",
  "inDaysMany": "Tra {count} giorni",
  "atRiskOne": "{count} socio è attualmente classificato a rischio.",
  "atRiskMany": "{count} soci sono attualmente classificati a rischio.",
  "confidence": "Confidenza",
  "confidenceHigh": "Alto",
  "confidenceMedium": "Medio",
  "confidenceLow": "Basso",
  "confidenceCurrent": "Attuale",
  "nextStep": "Prossimo passo: {action}",
  "highLow": "H: {high} ° L: {low} °",
  "precipitation": "Possibilità di precipitazioni",
  "keypadKey": "Quadrante {key}",
  "starKey": "stella stella",
  "hashKey": "Hah!",
  "deleteDigit": "Eliminare l'ultima cifra",
  "favouriteChat": "Conversazione preferita",
  "unfavouriteChat": "Rimuovi la conversazione dai preferiti",
  "deleteChat": "Eliminare la conversazione",
  "emptyHistory": "Ancora nessuna conversazione.",
  "emptyFavourites": "Non ci sono ancora conversazioni preferite.",
  "patterns": {
    "department_exposure_concentration": {
      "headline": "Il rischio delle entrate è concentrato nel {department}",
      "evidence": "Il {percent} % dell'esposizione corrente è collegato a {department} .",
      "implication": "Un'altalena in questo dipartimento potrebbe colpire rapidamente i contanti. Assegna un proprietario per rivedere i migliori crediti e driver di cancellazione in {department} questa settimana.",
      "actionLabel": "Recensione {department} dipendenza"
    },
    "outstanding_balance_department_concentration": {
      "headline": "Le bilance più importanti sono legate a {department}",
      "evidence": "Il {percent} % delle bilance aperte è di {department} .",
      "implication": "L'impatto delle collezioni è probabilmente più alto in {department}; la priorità di questa coda dovrebbe accelerare il recupero dei contanti.",
      "actionLabel": "Prioritizzare {department} collezioni"
    },
    "cancellation_day_of_week_spike": {
      "headline": "Le cancellazioni sono raggruppate su {day} s",
      "evidence": "Il {percent} % delle cancellazioni degli ultimi 90 giorni è avvenuto su {day} (circa {ratio} x altri giorni della settimana).",
      "implication": "Questo di solito indica un servizio specifico giorno o frizione pianificazione. Recensione {day} personale, finestre di prenotazione e motivi di cancellazione.",
      "actionLabel": "Audit {day} flusso di prenotazione"
    },
    "disengagement_department_overlap": {
      "headline": "I soci dell'At-risk sono indicizzati nel {department}",
      "evidence": "Il {percent} % dei soci a basso rischio di attivazione mappa a {department} modelli di attività.",
      "implication": "Una campagna di re-engagement mirata nel {department} potrebbe ridurre le perdite di reddito future.",
      "actionLabel": "Lancio {department} reazionazione"
    },
    "revenue_vs_activity_divergence": {
      "headline": "Le entrate aumentano più velocemente dell'attività socio",
      "evidence": "I ricavi sono in aumento del {revenueChange} % rispetto a 30 giorni, mentre l'attività di transazione è del {activityChange} %.",
      "implication": "La crescita dei ricavi può provenire dal prezzo/mix invece di una partecipazione più ampia. Controllare quali reparti e coorte soci stanno portando l'ascensore.",
      "actionLabel": "Convalida la qualità della crescita per segmento"
    },
    "receivables_cluster_by_department": {
      "headline": "I crediti più vecchi sono concentrati in {department}",
      "evidence": "{percent} % di 60+ saldi diurni sono in {department} .",
      "implication": "Collezioni trascinamento appare concentrato. Una strategia di invecchiamento focalizzata in {department} dovrebbe migliorare i recuperi.",
      "actionLabel": "Messa a fuoco 60+ day outreach in {department}"
    },
    "rising_risk_falling_usage": {
      "headline": "Il rischio dei soci è in aumento, mentre l'esposizione rimane strettamente concentrata",
      "evidence": "I soci a rischio sono aumentati di {delta} mentre il {department} rappresenta ancora il {percent} % dell'esposizione.",
      "implication": "Se il rischio socio continua ad aumentare, questa concentrazione può aumentare velocemente. Priorizzare l'accesso per i soci di alto equilibrio nel dipartimento esposto.",
      "actionLabel": "Contattare i soci ad alto equilibrio a rischio prima"
    }
  },
  "departments": {
    "membership": "Iscrizione",
    "golf": "Golf",
    "racquet": "Racchetta",
    "spa": "Centro benessere",
    "rooms": "Camere",
    "events": "Eventi",
    "fitness": "Fitness",
    "other": "Altro"
  },
  "this_insight_could_not_be_displayed": "Questa intuizione non potrebbe essere visualizzata.",
  "no_chart_data_is_available": "Nessun dato grafico è disponibile.",
  "series": "Serie:",
  "categories": ". Categorie:",
  "data_is_unavailable": "i dati non sono disponibili",
  "comparison_data_is_available_for": "I dati di confronto sono disponibili per",
  "of_the": "della",
  "displayed_periods_gaps_are_unavailable": "i periodi visualizzati; i vuoti non sono disponibili.",
  "partial_data_available_from": "Dati parziali: disponibili da",
  "categories_were_limited_to_the_most_significant_results": "Le categorie erano limitate ai risultati più significativi.",
  "view_data": "Visualizza i dati",
  "download_csv": "Scarica CSV",
  "open_in_module": "Aprire nel modulo",
  "exact_data_used_for": "Dati esatti utilizzati per",
  "current_period_is_incomplete_its_value_is_provisional": "* Il periodo attuale è incompleto; il suo valore è provvisorio.",
  "about_this_chart": "A proposito di questo grafico",
  "complete_through": "Completo attraverso",
  "generated": ") · generato",
  "latest_observed_record": "Ultimo record osservato:",
  "compared_with": "Rispetto a",
  "the_current_period_is_incomplete": "Il periodo attuale è incompleto.",
  "club_inventory": "Inventario del club",
  "show": "Mostra",
  "more": "di più",
  "fytd": "FYTD",
  "joined": "Abbonato",
  "renewal": "Rinnovamento",
  "account": "Conto",
  "contact": "Contatto",
  "recent_activity": "Attività recenti",
  "no_recent_activity_recorded": "Nessuna attività recente registrata.",
  "showing": "Mostrare",
  "of_at_least": "di almeno",
  "rows": "Voci.",
  "coverage": "Copertura",
  "comparison": "Confronto",
  "revision": "· revisione",
  "key_findings": "Risultati chiave",
  "supporting_chart_is_unavailable_or_no_longer_accessible": "Il grafico di supporto non è disponibile o non è più accessibile.",
  "risks_and_exceptions": "Rischi e eccezioni",
  "recommendations": "Raccomandazione",
  "intended_outcome": "Esito intenso:",
  "next_actions": "Prossime azioni",
  "coverage_limitations": "Copertura & Limitazioni",
  "about_this": "A proposito di questo",
  "data_used": "Dati utilizzati",
  "why": "Perche'?",
  "report_revision": "Revisione della relazione",
  "calculation_date": "Data di calcolo",
  "trading_picture": "Immagine di trading",
  "vs": "vs.",
  "revenue_by_department": "Entrate in servizio",
  "variance": "· varianza",
  "revenue_trend": "Tendenza delle entrate",
  "collections_by_method": "Collezioni per metodo",
  "privana_observations": "Privana osservazioni",
  "live_operational_weather": "Tempo operativo vivo",
  "live_club_forecast_updated": "Previsioni del club dal vivo · Aggiornato",
  "this_file_is_no_longer_stored_generated_files_are_retained_for_7_days": "Questo file non è più memorizzato. I file generati vengono conservati per 7 giorni.",
  "available_until": "Disponibile fino a esaurimento",
  "loading_preview": "Caricamento in anteprima...",
  "view_member": "Visualizza socio",
  "create_golf_outing": "Creare Golf Outing",
  "event_title": "Titolo dell'evento",
  "description": "Descrizione",
  "max_capacity": "Capacità massima",
  "start_time": "Avviare il tempo",
  "end_time": "Fine dell'orario",
  "location": "Luogo",
  "weather_forecast": "Previsioni del tempo",
  "golf_scope": "Campo da golf",
  "booked_players": "Giocatori prenotati",
  "tee_utilisation": "Utilizzo di Tee",
  "occupied_slots": "Fessure occupate",
  "available_slots": "Fessure disponibili",
  "forecast_date": "Data di previsione",
  "operational_risk": "Rischio operativo",
  "current_snapshot": "Istantanea attuale",
  "previous_year": "Anno precedente",
  "for_the_displayed_periods": " per i periodi visualizzati",
  "creating": "Creare...",
  "untitled": "Senza titolo",
  "report": "Relazione",
  "noMatches": "Nessun risultato corrispondente",
  "unavailableData": "Queste informazioni non sono disponibili in questo momento.",
  "assistUnavailable": "Assistere temporaneamente non disponibile. Si prega di riprovare questo messaggio.",
  "draftConflict": "Questa bozza non potrebbe essere aggiornata. Ricaricala prima di provare di nuovo.",
  "queued": "Richiesta accettata.",
  "running": "Privana Assist sta lavorando...",
  "finalising": "Finisci la tua risposta...",
  "cancelling": "Fermare...",
  "paused": "In pausa",
  "failed": "Incapace di continuare",
  "openFile": "Aperto {name}",
  "downloadFile": "Scarica {name}",
  "termUnavailable": "Le informazioni a termine per l'adesione non possono essere controllate in questo momento.",
  "noRenewal": "Nessuna data di rinnovo esplicita registrata.",
  "noTerm": "Nessun termine di appartenenza attuale registrato.",
  "financeUnavailable": "Le informazioni finanziarie non potrebbero essere controllate in questo momento.",
  "accountAvailable": "Posizione dell'account disponibile.",
  "viewProfile": "Visualizza profilo utente",
  "previewFailed": "Anteprima non disponibile.",
  "downloadFailed": "Scarica non disponibile.",
  "openFailed": "Aprire non disponibile.",
  "restricted": "Non hai il permesso di visualizzare queste informazioni.",
  "references": {
    "outstanding": "Bilancio eccezionale",
    "cancelled": "Prenotazione cancellata o rimborso",
    "engagement": "Bassa tendenza di fidanzamento"
  },
  "available": "Disponibile",
  "partial": "Parziale",
  "unavailable": "Non disponibile",
  "high": "Alto",
  "medium": "Medio",
  "low": "Basso",
  "unknown": "Sconosciuto",
  "result": "Risultato",
  "weatherLow": "Buon per le operazioni all'aperto",
  "weatherElevated": "Alcuni rischi di interruzione",
  "weatherHigh": "Rischio di interruzione",
  "gusts": "bufere",
  "low_source_coverage": "alcune fonti hanno una copertura limitata",
  "insufficient_points": "solo i dati storici limitati sono disponibili",
  "partially_available": "non tutti i domini richiesti hanno restituito evidenze utilizzabili",
  "no_comparison_period": "il confronto precedente non è disponibile",
  "provisional_period": "il periodo corrente non è completo",
  "source_coverage": "la copertura della fonte è limitata",
  "coverageLimited": "{names} dati non sono stati disponibili per questo periodo, quindi la valutazione operativa del rapporto è limitata.",
  "coverageHelp": "Questo rapporto include le prove disponibili e nota eventuali limitazioni qui sotto.",
  "revenueRecords": "Resoconti delle entrate",
  "memberRecords": "Registri dei soci",
  "receivableRecords": "Registri crediti",
  "eventRecords": "Record di eventi",
  "elementRecords": "Record di elementi",
  "managementRecords": "Registrazioni di gestione disponibili",
  "and": " e ",
  "tableLabel": "{title} tavolo",
  "becauseRecordsBegin": " perché i record cominciano su {date}",
  "completed": "Completo",
  "unspecified": "Non specificato",
  "none": "Nessuno",
  "confidenceBadge": "{value} fiducia",
  "analyticalDescription": "Mostrando {series} di {dimension} .",
  "analyticalView": "Vista analitica.",
  "governedResult": "Risultato analitico governato",
  "supportedEvidence": "Sostenuto dalle prove disponibili.",
  "collapse": "Colpisco",
  "briefing": "Briefing",
  "working": "Lavorare...",
  "originalReport": "Rapporto originale",
  "revisionReport": "Revisione della relazione precedente",
  "extensionReady": "Pronta Estensione",
  "transferringTarget": "Trasferimenti a {target}...",
  "consultControls": "Controlli delle chiamate di consultazione",
  "consultDialpad": "Consultazione dialpad",
  "closeDialpad": "Chiusura con bottone",
  "sendDtmf": "Invia DTMF {digit}",
  "unmute": "Incontaminato",
  "hangUp": "Tieni duro.",
  "inProgress": "In corso",
  "consultation_active": "Consulenza attiva",
  "financeStatuses": {
    "draft": "Bozza",
    "submitted": "Inviato",
    "board_approved": "Approvazione da parte del Consiglio",
    "approved": "Approvazione",
    "locked": "Bloccato",
    "favourable": "Favorevole",
    "adverse": "Discussione",
    "on_budget": "Bilancio",
    "consistent": "Coerente",
    "mismatch": "Mancata corrispondenza",
    "reconciled": "Riconciliazione",
    "explained_difference": "Differenza spiegata",
    "unexplained_difference": "Differenza inspiegabile",
    "insufficient_evidence": "Prove insufficienti"
  },
  "destination_prepared": "Destinazione preparata",
  "destination_ringing": "Destinazione anello",
  "consultation_failed": "La consultazione è fallita",
  "consultation_cancelling": "Annullamento della consultazione",
  "consultation_cancelled": "Annullamento della consultazione",
  "clubFallback": "Club Club",
  "atAGlance": "{club} a colpo d'occhio",
  "cc": "CC",
  "bcc": "BCC",
  "proceed": "Come vorresti procedere?",
  "selectMemberFailed": "Non è possibile selezionare il socio. Si prega di riprovare.",
  "reviewSms": "Si prega di rivedere e confermare prima di inviare questo SMS .",
  "confirmationCancelled": "La conferma e' stata annullata, nessun messaggio e' stato inviato.",
  "verifyAction": "Assistere temporaneamente non disponibile. Si prega di verificare lo stato di azione prima di riprovare.",
  "discardedEdit": "I progetti scartati non possono essere modificati.",
  "saveDraftFailed": "Non si può salvare",
  "discardDraftFailed": "Non si può scartare",
  "forwardedMessage": "Messaggio inoltrato",
  "smsFailed": "SMS non è riuscito a mandare.",
  "smsSimulation": "SMS solo simulazione — nessun messaggio di testo reale è stato inviato.",
  "smsSimulationLine": "Solo simulazione ⚠️ Nessun SMS è stato inviato al socio.",
  "smsNotSent": "SMS non inviato",
  "smsSuccess": "Messaggio inviato con successo",
  "smsSent": "SMS inviato ✅",
  "golfOutingPlaceholder": "Uscita di golf",
  "selectCourse": "Seleziona un corso...",
  "courseVenue": "Nome del corso / sede",
  "allGolfCourses": "Tutti i campi da golf",
  "member_back_to_accommodations": "Torna alla lista degli alloggi",
  "member_your_booking": "la tua prenotazione",
  "member_confirm_occupancy_settlement_method_and_submit_your_booking_request": "Confermare l'occupazione, il metodo di regolamento, e inviare la vostra richiesta di prenotazione.",
  "member_booking_request_confirmed": "Richiesta prenotazione confermata",
  "member_your_accommodation_request_is_now_pending_confirmation_from_the_club_team": "La vostra richiesta di alloggio è ora in attesa di conferma dal team del club.",
  "member_reservation_reference": "Riferimento prenotazione:",
  "member_photos_coming_soon": "Foto in arrivo",
  "member_previous_photo": "Foto precedente",
  "member_next_photo": "La foto successiva",
  "member_room_plan": "Piano d'attesa",
  "member_adults": "adulti ·",
  "member_children": "bambini bambini",
  "member_anything_we_should_prepare": "C'è qualcosa che dovremmo preparare?",
  "member_special_requests_optional": "Richieste speciali (facoltativo)",
  "member_late_arrival_adjoining_rooms_dietary_preferences_or_anything_else": "Arrivo tardivo, camere comunicanti, preferenze dietetiche o altro.",
  "member_review_confirm": "Recensione & conferma",
  "member_nights": "Notti",
  "member_rooms_guests": "Camere · Ospiti",
  "member_rooms": "camere ·",
  "member_nightly_rate_per_room": "Tariffa notturna (per camera)",
  "member_add_to_member_account": "Aggiungi all'account socio",
  "member_pay_by_card_online": "Paga con carta online",
  "member_pay_on_arrival": "Pagamento all'arrivo",
  "member_this_room_type_does_not_yet_have_a_configured_rate_please_contact_the_club": "Questo tipo di camera non ha ancora una tariffa configurata. Si prega di contattare il club.",
  "member_visual_coming_soon": "Visiva in arrivo",
  "member_rooms_available": "camere disponibili",
  "member__night": "/ notte",
  "member_stay_in": "Rimani qui",
  "member_style": "stile",
  "member_choose_your_dates_and_room_setup_to_see_currently_available_suites": "Scegli le date e le impostazioni della camera per vedere le suite attualmente disponibili.",
  "member_check_in_check_out": "Check-in / Check-out",
  "member_guests_rooms": "Ospiti / Camere",
  "member_add_rooms_as_needed": "Aggiungere le camere come necessario",
  "member_decrease_rooms": "Diminuzione delle camere",
  "member_increase_rooms": "Aumento delle camere",
  "member_adults_2": "Adulti",
  "member_children_2": "Bambini",
  "member_check_availability": "Verifica disponibilità",
  "member_step_2": "Passo 2",
  "member_available_room_types": "Tipi di camera disponibili",
  "member_loading_suites_and_rooms": "Caricamento di suite e camere…",
  "member_no_rooms_are_available_to_request_right_now": "Non sono disponibili camere a richiesta in questo momento.",
  "member_accommodation_room_details": "Dettagli dell'alloggio",
  "member_close_room_details": "Dettagli della camera",
  "member_total_estimate": "Stime totali",
  "member_continue_to_booking": "Continua a prenotare",
  "member_discover_club_programming": "Scopri la programmazione del club",
  "member_loading_activities": "Caricamento delle attività...",
  "member_no_activities_are_available_right_now": "Non sono disponibili attività in questo momento.",
  "member_view_sessions": "Visualizza le sessioni",
  "member_book_or_manage_your_reservation": "Prenota o gestisci la tua prenotazione.",
  "member_back_to_activities": "Torna alle attività",
  "member_loading_sessions": "Le sessioni di carico...",
  "member_no_sessions_are_scheduled_yet": "Non sono ancora programmate sessioni.",
  "member_dismiss_notification": "Discorso della notifica",
  "member_players": "giocatori ·",
  "member_can_cancel": "Può annullare",
  "member_total_cost": "Costo totale",
  "member_no_players_listed": "Nessun giocatore elencato",
  "member_no_add_ons": "Nessun componente aggiuntivo",
  "member_cancellation_policy_status": "Stato della politica di cancellazione",
  "member_you_may_cancel_this_booking_online_under_the_club_s_cancellation_policy": "È possibile annullare questa prenotazione online in base alla politica di cancellazione del club.",
  "member_cutoff": "Ritaglio:",
  "member_hours_before_tee_time": "ore prima dell'ora del tee",
  "member_cancel_booking": "Annulla prenotazione",
  "member_you_may_cancel_this_racquet_booking_through_member_portal_cancellation": "È possibile annullare questa prenotazione Racquet attraverso la cancellazione del portale socio.",
  "member_you_may_cancel_this_spa_booking_through_member_portal_cancellation": "È possibile annullare questa prenotazione Spa attraverso la cancellazione del portale socio.",
  "member_fitness_booking": "Prenotazione di fitness",
  "member_you_may_cancel_this_fitness_booking_through_member_portal_cancellation": "È possibile annullare questa prenotazione Fitness attraverso la cancellazione del portale socio.",
  "member_full_stay_cost": "Costo totale del soggiorno",
  "member_you_may_cancel_this_hotel_rooms_booking_through_member_portal_cancellation": "È possibile annullare questa prenotazione Hotel / Camere attraverso la cancellazione del portale socio.",
  "member_need_to_adjust_this_booking_please_contact_the_club": "È necessario regolare questa prenotazione? Si prega di contattare il club.",
  "member_club_overview": "Panoramica del club",
  "member_resolving_member_profile": "Risolvere il profilo dei soci",
  "member_welcome_to_your_private_sanctuary": "Benvenuti nel vostro santuario privato",
  "member_let_s_play": "Giochiamo!",
  "member_upcoming_bookings": "Le prossime prenotazioni",
  "member_your_next_experiences_at_the_club": "Le tue prossime esperienze al club",
  "member_check_back_here_soon_for_more_exciting_club_news": "Torna qui presto per più eccitanti notizie del club!",
  "member_loading_club_news": "Caricamento delle news del club",
  "member_member_updates": "Aggiornamenti degli utenti",
  "member_preparing_pdf_viewer": "Preparare PDF spettatori...",
  "member_mark_as_read": "Mark come letto",
  "member_member_bookings": "Prenotazioni degli Stati soci",
  "member_all_upcoming_experiences": "Tutte le prossime esperienze",
  "member_upcoming": "in arrivo",
  "member_upcoming_bookings_carousel": "imminenti Prenotazioni carosello",
  "member_select_a_booking_to_view_details": "Selezionare una prenotazione per visualizzare i dettagli",
  "member_choose_a_booking_from_the_list_to_see_policy_information_players_add_ons_payment_details_and_available_actions": "Scegli una prenotazione dall'elenco per visualizzare informazioni politiche, giocatori, add-on, dettagli di pagamento e azioni disponibili.",
  "member_close_cancellation_confirmation": "Chiudi conferma della cancellazione",
  "member_cancel_this_tee_time": "Cancellare questo orari di partenza?",
  "member_this_will_cancel_your_tee_time_and_update_your_member_account_this_cannot_be_undone_online": "Questo cancellerà il vostro tempo e aggiornerà il vostro account socio. Questo non può essere annullato online.",
  "member_keep_booking": "Continua a prenotare",
  "member_cancel_tee_time": "Annullare il Tempo di Tee",
  "member_cancel_this_racquet_booking": "Annullare questa prenotazione Racquet?",
  "member_this_will_cancel_your_booking_and_apply_the_club_cancellation_policy": "Questo annullerà la prenotazione e applicherà la politica di cancellazione del club.",
  "member_cancel_this_spa_booking": "Cancellare questa prenotazione Spa?",
  "member_cancel_this_fitness_booking": "Cancellare questa prenotazione Fitness?",
  "member_cancel_this_hotel_rooms_booking": "Annullare questa prenotazione Hotel / Camere?",
  "member_this_will_cancel_your_stay_and_apply_the_club_cancellation_policy": "Questo annullerà il vostro soggiorno e applicherà la politica di cancellazione del club.",
  "member_explore_exclusive_events": "Esplora eventi esclusivi...",
  "member_search_titles_venues_or_occasion_type": "Titoli di ricerca, luoghi, o tipo di occasione",
  "member_event_timeframe": "Tempi di evento",
  "member_my_calendar": "Il mio calendario",
  "member_confirmed_attendance": "Presenza confermata",
  "member_accessibility": "Accessibilità",
  "member_remove_guest": "Rimuovi gli ospiti",
  "member_attendance_notes": "Note di partecipazione",
  "member_dietary_needs_accessibility_notes_or_concierge_requests": "Le esigenze alimentari, le note di accessibilità o le richieste di concierge",
  "member_book_facilities": "Prenotare servizi",
  "member_choose_your_next_activity": "Scegli la tua prossima attività",
  "member_facilities_could_not_be_refreshed": "Le strutture non potrebbero essere rinfrescate.",
  "member_loading_facilities": "Servizi di caricamento",
  "member_facilities_will_appear_here_when_your_club_enables_them": "Le strutture appariranno qui quando il vostro club gli permette.",
  "member_available_times": "ORARI DISPONIBILI",
  "member_loading_availability": "Caricamento della disponibilità...",
  "member_no_available_times_for_this_day": "Nessun tempo disponibile per questo giorno.",
  "member_loading_schedule": "Caricamento in corso...",
  "member_no_upcoming_fitness_classes_with_availability": "Nessun corso di fitness imminente con disponibilità.",
  "member_sessions": "sessioni",
  "member_view_open_groups": "Visualizza i gruppi aperti",
  "member_view_rates": "Visualizza tariffe",
  "member_no_available_tee_times_for_this_day": "Nessun tempo disponibile per questo giorno.",
  "member_up_to": "Fino a",
  "member_players_2": "giocatori",
  "member_book_now": "Prenota ora",
  "member_rates_are_not_available_yet_please_contact_the_pro_shop": "Le tariffe non sono ancora disponibili. Si prega di contattare il negozio pro.",
  "member_back_to_tee_times": "Ritorno ai tempi del tee",
  "member_course_rates": "Tassi di corso",
  "member_loading_course": "Corso di caricamento...",
  "member_select_rate_type": "Selezionare il tipo di tasso",
  "member_member_rates": "Tassi",
  "member_guest_rates": "Prezzi per gli ospiti",
  "member_pricing": "prezzi",
  "member__hole": "- Buco",
  "member_fetching_available_courses_for_your_club": "Ottenere corsi disponibili per il vostro club.",
  "member_choose_your_course": "Scegli il tuo corso",
  "member_select_a_course_to_view_available_tee_times": "Selezionare un corso per visualizzare i tempi disponibili.",
  "member_no_active_courses_are_available_for_booking_yet": "Non sono ancora disponibili corsi attivi per la prenotazione.",
  "member_court": "campo",
  "member_private_booking": "Prenotazione privata",
  "member_open_match": "Corrispondenza aperta",
  "member_match_type": "Tipo di partita",
  "member_competitive": "Competitività",
  "member_who_can_join": "Chi può unirsi",
  "member_host_approval": "Approvazione host",
  "member_direct_join": "Unisciti alla guida",
  "member_optional_note": "Nota facoltativa",
  "member_anything_players_should_know": "C'è qualcosa che i giocatori dovrebbero sapere?",
  "member_add_to_your_booking": "Aggiungi alla tua prenotazione",
  "member_view_other_times": "Vedi altre volte",
  "member_close_player_sheet": "Chiudi il foglio del giocatore",
  "member_search_by_name": "Ricerca per nome",
  "member_searching_members": "soci della ricerca",
  "member_sport_not_supported": "Sport non supportato",
  "member_we_couldn_t_recognize_this_sport_please_return_to_facilities": "Non siamo riusciti a riconoscere questo sport, si prega di tornare alle strutture.",
  "member_back_to_courts": "Torna ai campi",
  "member_confirm_your_court": "Conferma la tua corte",
  "member_book_a_court": "Prenota un campo",
  "member_create_open_match": "Creare una partita aperta",
  "member_select_open_match_type": "Selezionare il tipo di partita aperta",
  "member_select_join_policy": "Seleziona la politica di unisciti",
  "member_open_match_note": "Nota di partita aperta",
  "member_optional_details_for_players_joining": "Dettagli opzionali per i giocatori che si uniscono",
  "member_mobile_for_updates": "Mobile per aggiornamenti",
  "member_email_for_confirmation": "Email per la conferma",
  "member__add_player": "+ Aggiungi giocatore",
  "member_maximum_players_reached_for_this_court": "Massimi giocatori raggiunti per questa corte.",
  "member_enhance_your_visit": "Migliora la tua visita",
  "member_no_add_ons_available_for_this_sport": "Nessun componente aggiuntivo disponibile per questo sport.",
  "member_racquet_booking": "Prenotazione racchetta",
  "member_estimated_total": "Totale stimato",
  "member_calculated_from_live_pricing_policy": "Calcolato dalla politica dei prezzi in diretta",
  "member_default_session": "Sessione predefinita:",
  "member_member_rate_on_file": "Tasso socio del file",
  "member_guest_rate_on_file": "Tasso degli ospiti sul file",
  "member_left": "sinistra",
  "member_skill": "Competenze",
  "member_vacant_spot": "Posto vacante",
  "member_no_pending_join_requests_right_now": "Nessuna richiesta di adesione in sospeso in questo momento.",
  "member_pending_invites": "Inviti a pagamento",
  "member_back_to_racquet_availability": "Torna alla disponibilità di racchette",
  "member_loading_match_details": "Caricamento dei dettagli della partita...",
  "member_back_to_facilities": "Torna ai servizi",
  "member_no_courts_available_for": "Nessun campo disponibile per",
  "member_select_court_date": "Seleziona la data del campo",
  "member_open_matches": "Fiammiferi aperti",
  "member_loading_open_matches": "Caricamento delle partite aperte...",
  "member_no_open_matches_available_for_this_date": "Non sono disponibili partite aperte per questa data.",
  "member_choose_a_time": "Scegli un tempo",
  "member_no_available_start_times_for_this_day": "Non sono disponibili tempi di inizio per questo giorno.",
  "member_available_start_times": "Tempi di inizio disponibili",
  "member_choose_a_court": "Scegli un campo",
  "member_no_courts_are_available_for_this_time": "Non sono disponibili campi per questo tempo.",
  "member_no_slots_available_for_this_day": "Nessun slot disponibile per questo giorno.",
  "member_open_matches_to_join": "Aprire le partite per iscriversi",
  "member_spots_left": "posti a sinistra",
  "member_your_match": "La tua partita",
  "member_view_requests": "Visualizza le richieste",
  "member_payment_required": "Pagamento richiesto",
  "member_due": "dovuto",
  "member_add_to_account": "Aggiungi al conto",
  "member_pay_online": "Paga online",
  "member_you_are_in_this_match": "Sei in questa partita",
  "member_host_controls": "Controlli host",
  "member_manage_open_match": "Gestire la partita aperta",
  "member_manage_open_match_requests": "Gestire le richieste di corrispondenza aperte",
  "member_pay_online_for_open_match": "Paga online per partita aperta",
  "member_payment_summary": "Riepilogo dei pagamenti",
  "member_match_time_date": "Tempo di corrispondenza/data",
  "member_cardholder_name": "Nome del titolare",
  "member_card_number": "Numero della carta",
  "member_expiry": "Scadenza",
  "member_mm_yy": "MM/YY",
  "member_billing_postcode_zip": "Codice postale di fatturazione / ZIP",
  "member_online_card_payments_are_not_enabled_yet": "I pagamenti online delle carte non sono ancora abilitati.",
  "member_confirm_payment": "Conferma del pagamento",
  "member_members_portal": "soci PORTALI",
  "member_browse_partner_clubs_and_request_a_guest_pass_to_visit": "Sfoglia i club partner e richiedi un pass per visitare.",
  "member_search_by_club_or_location": "Ricerca per club o posizione",
  "member_loading_reciprocal_clubs": "Caricamento di club reciproci...",
  "member_no_partner_clubs_available_yet": "Non sono ancora disponibili club partner.",
  "member_amenities_coming_soon": "Servizi in arrivo",
  "member_visit_website": "Visita il sito web",
  "member_reciprocal_club": "Club Reciproco",
  "member_amenities_coming_soon_2": "I servizi arriveranno presto.",
  "member_visit_date": "Data di visita",
  "member_note_message_optional": "Nota / messaggio (opzionale)",
  "member_let_us_know_anything_helpful_for_your_visit": "Fateci sapere qualcosa di utile per la vostra visita.",
  "member_request_sent": "Richiesta inviata!",
  "member_your_guest_pass_request_has_been_submitted_we_ll_notify_you_once_it_s_approved": "La richiesta del tuo pass è stata presentata. Ti avviseremo una volta approvata.",
  "member_request_reference": "Richiesta di riferimento:",
  "member_back_to_reciprocal_clubs": "Torna ai club reciproci",
  "member_back_to_services": "Torna ai servizi",
  "member_choose_a_service": "Scegli un servizio",
  "member_search_services": "Servizi di ricerca",
  "member_loading_services": "Servizi di caricamento...",
  "member_no_spa_services_available": "Nessun servizio spa disponibile.",
  "member_holes": "buche buche",
  "member_confirm_your_time": "Conferma il tuo tempo",
  "member_please_select_holes_to_continue": "Si prega di selezionare i buche per continuare.",
  "member_open_group": "GRUPPO APERTO",
  "member_open_group_toggle": "Aprire il gruppo di gioco",
  "member_open_group_2": "Gruppo aperto",
  "member_open_groups_not_available_for_this_player_mix": "I gruppi aperti non sono disponibili per questo mix di giocatori.",
  "member_looking_for": "Cercare",
  "member_open_group_size": "Dimensione del gruppo aperto",
  "member_player": "giocatore",
  "member_min_handicap_optional": "Min handicap (opzionale)",
  "member_e_g_10_0": "ad es. 10.0",
  "member_max_handicap_optional": "Max handicap (opzionale)",
  "member_e_g_24_0": "es. 24.0",
  "member_note_for_guests_optional": "Nota per gli ospiti (opzionale)",
  "member_share_expectations_or_preferences": "Condividi le aspettative o le preferenze",
  "member_spots_available": "Punti disponibili:",
  "member_enhance_your_round": "Migliora il tuo round",
  "member_open_groups_to_join": "Aprire gruppi per unirsi",
  "member_play_with_others": "Gioca con gli altri",
  "member_no_open_groups_for_this_date_yet": "Nessun gruppo aperto per questa data ancora.",
  "member__spots_available": "· Spots disponibili:",
  "member_golf_booking": "Golf prenotazione",
  "member_open_group_2_3": "Gruppo aperto",
  "member_retry_price": "Prezzo di recupero",
  "member_includes_add_ons_selected": "Include componenti aggiuntivi selezionati",
  "member_booking_checkout": "Prenotazione checkout",
  "member_go_to_dashboard": "Vai al cruscotto",
  "member_member_profile": "Profilo dei soci",
  "member_mobile_bottom_navigation": "Navigazione in basso mobile",
  "member_clearing": "Cancellazione",
  "member_loading_notifications": "Caricamento delle notifiche...",
  "member_no_notifications_yet": "Nessuna notifica ancora",
  "member_pending_confirmation": "Conferma del pagamento",
  "member_select_a_room_type": "Seleziona un tipo di camera",
  "member_confirm_booking": "Conferma prenotazione",
  "member_member_account_club_billing": "Conto socio / club fatturazione",
  "member_fitness_class": "Lezione di fitness",
  "member_hotel_stay": "Soggiorni in hotel",
  "member_venue_service": "Luogo / servizio",
  "member_you_may_cancel_this_dining_reservation_through_member_portal_cancellation": "È possibile annullare questa prenotazione Cenere attraverso la cancellazione del portale socio.",
  "member_close_all_club_news": "Chiudi tutte le news del club",
  "member_close_entry_notification": "Chiudere la notifica di entrata",
  "member_close_club_news": "Ultime notizie del club",
  "member_close_all_upcoming_bookings": "Chiudi tutte le prenotazioni imminenti",
  "member_past_experiences": "esperienze passate",
  "member_live_experiences": "esperienze dal vivo",
  "member_no_events_match_your_search_right_now": "Nessun evento corrisponde alla tua ricerca in questo momento.",
  "member_no_past_events_just_yet": "Non ci sono ancora eventi passati.",
  "member_no_upcoming_events_right_now_please_check_back_soon": "Non ci sono eventi imminenti in questo momento. Si prega di controllare presto.",
  "member_signature_event": "Evento di firma",
  "member_an_exceptional_club_gathering": "Una riunione eccezionale del club.",
  "member_club_venue": "Sede del club",
  "member_guest_details": "Dettagli degli ospiti",
  "member_confirm_attendance": "Confermare la partecipazione",
  "member_open_match_enabled": "Attivare la partita aperta",
  "member_none_selected": "Nessuno selezionato",
  "member_book_court": "Corte di giustizia",
  "member_pending_join_requests": "In attesa di richieste di adesione",
  "member_select_a_court": "Seleziona un campo",
  "member_selected_day": "Giorno selezionato",
  "member_request_guest_pass": "Richiesta Passeggero",
  "member_all_caught_up": "Tutti catturati",
  "member_unable_to_load_activities": "Incapace di caricare le attività.",
  "member__count_upcoming_session": "{count} prossima sessione",
  "member__count_upcoming_sessions": "{count} prossime sedute",
  "member_time_to_be_announced": "Tempo di essere annunciato",
  "member_unable_to_update_booking": "Non è possibile aggiornare la prenotazione.",
  "member_join_waitlist": "Iscriviti alla lista dei desideri",
  "member_join": "Iscriviti",
  "member__count_booked": "{count} prenotato",
  "member_unable_to_clear_notifications": "Incapace di cancellare le notifiche",
  "member__count_new": "{count} nuovo",
  "member_unable_to_load_reciprocal_clubs": "Incapace di caricare club reciproci.",
  "member_please_select_a_visit_date_to_request_a_guest_pass": "Seleziona una data di visita per richiedere un pass per gli ospiti.",
  "member_unable_to_submit_request": "Incapace di presentare richiesta.",
  "member_we_could_not_load_accommodations_right_now_please_try_again_shortly": "Non abbiamo potuto caricare le sistemazioni in questo momento. Si prega di riprovare a breve.",
  "member_please_choose_a_check_in_and_check_out_date": "Si prega di scegliere una data di check-in e check-out.",
  "member_check_out_must_be_after_check_in": "Il check-out deve essere dopo il check-in.",
  "member_please_add_at_least_one_guest": "Si prega di aggiungere almeno un ospite.",
  "member_please_choose_valid_dates_before_requesting_a_booking": "Si prega di scegliere le date valide prima di richiedere una prenotazione.",
  "member_we_were_unable_to_submit_your_request_please_try_again": "Non siamo stati in grado di inviare la vostra richiesta.",
  "member_unable_to_load_event_details": "Non è possibile caricare i dettagli dell'evento",
  "member_each_guest_needs_a_first_and_last_name": "Ogni ospite ha bisogno di un nome e cognome.",
  "member_registration_failed": "Registrazione fallita",
  "member_location_coming_soon": "Location in arrivo",
  "member_availability_on_request": "Disponibilità su richiesta",
  "member_select_your_stay_dates": "Seleziona le date del soggiorno",
  "member_date_to_be_announced": "Data di annuncio",
  "member_you_re_in": "Tu sei dentro",
  "member__count_of_capacity_places_remaining": "{count} posti rimasti su {capacity}",
  "member_guests_allowed_up_to_count": "Ospiti ammessi: fino a {count}",
  "member_guests_allowed": "A disposizione degli ospiti",
  "member_guests_not_permitted": "Ospiti non ammessi",
  "member_more_details_will_be_announced_shortly": "Ulteriori dettagli saranno annunciati a breve.",
  "member_host_member": "Host · socio",
  "member_live_price": "Prezzo in corso",
  "member_add_name": "Aggiungi {name}",
  "member_member_on_file": "socio della Commissione",
  "member_search_member_or_enter_guest_name": "Cerca socio o inserisci il nome dell'ospite",
  "member_search_and_select_a_member": "Cerca e seleziona un socio",
  "member_host": "Ospite",
  "member_tap_to_book": "Toccare per prenotare",
  "member_join_now": "Iscriviti ora",
  "member_request_spot": "Luogo di richiesta",
  "member_balance_loading": "Caricamento del saldo",
  "member_explore_events": "Esplora gli eventi",
  "member_racquet_open_match": "Racquet · partita aperta",
  "member_club_reservation": "Prenotazione Club",
  "member_this_booking_was_paid_online_please_contact_the_club_directly_if_you_wish_to_cancel_or_discuss_a_refund": "Questa prenotazione è stata pagata online. Si prega di contattare direttamente il club se si desidera annullare o discutere di un rimborso.",
  "member_the_online_cancellation_period_has_passed_please_contact_the_club": "Il periodo di cancellazione online è passato. Contattare il club.",
  "member_online_cancellation_is_not_available_for_this_booking_please_contact_the_club": "La cancellazione online non è disponibile per questa prenotazione. Si prega di contattare il club.",
  "member_unable_to_cancel_booking": "Incapace di cancellare la prenotazione.",
  "member_your_tee_time_has_been_cancelled": "Il suo tempo e' stato cancellato.",
  "member_this_booking_is_inside_the_cancellation_notice_period_please_contact_the_club_to_cancel_this_booking": "Questa prenotazione è all'interno del periodo di cancellazione. Si prega di contattare il club per annullare questa prenotazione.",
  "member_please_contact_the_club_to_cancel_this_booking": "Si prega di contattare il club per cancellare questa prenotazione.",
  "member_refund_outcome_no_refund": "Rimborso: nessun rimborso",
  "member_cancellation_requires_manual_review": "La cancellazione richiede la revisione manuale.",
  "member_unable_to_cancel_booking_please_contact_the_club": "Non è possibile cancellare la prenotazione. Contattare il club.",
  "member_your_racquet_booking_has_been_cancelled": "La prenotazione della racchetta è stata annullata.",
  "member_your_spa_booking_has_been_cancelled": "La tua prenotazione è stata cancellata.",
  "member_your_fitness_booking_has_been_cancelled": "La prenotazione di fitness è stata cancellata.",
  "member_this_stay_is_inside_the_cancellation_notice_period_please_contact_the_club_to_cancel_this_booking": "Questo soggiorno è all'interno del periodo di cancellazione. Si prega di contattare il club per annullare questa prenotazione.",
  "member_your_hotel_booking_has_been_cancelled": "La prenotazione dell'hotel è stata cancellata.",
  "member_cancellation_not_available_via_the_mobile_app": "Cancellazione non disponibile tramite l'app mobile.",
  "member_the_online_cancellation_window_has_closed_please_contact_the_club": "La finestra di cancellazione online è chiusa. Si prega di contattare il club.",
  "member_this_reservation_can_no_longer_be_cancelled": "Questa prenotazione non può più essere cancellata.",
  "member_this_reservation_could_not_be_found_please_contact_the_club": "Questa prenotazione non è stata trovata. Si prega di contattare il club.",
  "member_cancellation_is_not_currently_available_please_contact_the_club": "La cancellazione non è attualmente disponibile. Contattare il club.",
  "member_your_tee_time_is_confirmed": "Il tuo orari di partenza è confermato",
  "member_your_table_is_reserved": "Il tuo tavolo è riservato",
  "member_your_stay_is_confirmed": "Il vostro soggiorno è confermato",
  "member_your_open_match_is_live": "La tua partita aperta è dal vivo",
  "member_your_booking_is_confirmed": "La prenotazione è confermata",
  "member_open_match_created": "Open match creato",
  "member_your_match_is_now_visible_to_eligible_club_members_who_can_join_or_request_a_place_using_your_chosen_join_policy": "La tua partita è ora visibile ai soci del club idonei, che possono aderire o richiedere un posto utilizzando la politica di adesione scelta.",
  "member_loading_booking_details": "Caricamento dei dettagli della prenotazione",
  "member_club_experience": "Esperienza di Club",
  "member_players_count_of_capacity": "Giocatori · {count} di {capacity}",
  "member__count_places_open_type_policy": "{count} posti disponibili · {type} · {policy}",
  "member__adults_adults_children_children_rooms_rooms": "{adults} adulti, {children} bambini · {rooms} camere",
  "member_stay_guests": "Soggiorni ospiti",
  "member_unable_to_load_course_details_right_now": "Non è possibile caricare i dettagli del corso in questo momento.",
  "member_unable_to_load_this_tee_time_please_return_to_tee_times_and_try_again": "Non è possibile caricare questo orari di partenza. Si prega di tornare a tee tempi e riprovare.",
  "member_at_least_one_player_is_required": "Almeno un giocatore è richiesto.",
  "member_please_select_holes_9_or_18": "Si prega di selezionare i buche (9 o 18).",
  "member_select_how_many_players_you_want_to_join_your_open_group": "Selezionare quanti giocatori si desidera unire al vostro gruppo aperto.",
  "member_open_group_spots_would_exceed_the_maximum_of_4_players": "I punti di gruppo aperti supererebbero il massimo di 4 giocatori.",
  "member_this_tee_time_is_no_longer_available_please_reselect_a_tee_time": "Questo orari di partenza non è più disponibile, si prega di deselezionare un orari di partenza.",
  "member_we_can_t_price_this_tee_time_right_now_please_try_another_time_or_contact_the_club": "Non possiamo pagare questo orari di partenza adesso. Si prega di provare un'altra volta o contattare il club.",
  "member_we_couldn_t_calculate_your_booking_price_try_again_in_a_moment": "Non abbiamo potuto calcolare il vostro prezzo di prenotazione, riprovare in un momento.",
  "member_unable_to_join_this_open_group_right_now": "Incapace di aderire a questo gruppo aperto in questo momento.",
  "member_we_could_not_complete_the_booking_please_check_your_details_and_try_again": "Non abbiamo potuto completare la prenotazione. Si prega di controllare i vostri dettagli e riprovare.",
  "member_court_details_not_loaded": "Dati della Corte non caricati",
  "member_start_time_missing": "Iniziare il tempo mancante",
  "member_please_resolve_player_details": "Si prega di risolvere i dettagli del giocatore",
  "member_unable_to_load_court_details_right_now": "Incapace di caricare i dettagli del campo in questo momento.",
  "member_please_select_a_valid_duration_for_this_court_and_time": "Si prega di selezionare una durata valida per questo campo e l'ora.",
  "member_invalid_sport_type": "Tipo di sport non valido",
  "member_unable_to_join_open_match_right_now": "Incapace di entrare in partita aperta in questo momento.",
  "member_spot_joined_payment_required_to_finalize_your_spot": "Spot si è unito. Pagamento necessario per finalizzare il vostro posto.",
  "member_request_sent_you_will_be_notified_if_approved": "Richiesta inviata. Verrà notificato se approvato.",
  "member_unable_to_complete_payment_right_now": "Incapace di completare il pagamento in questo momento.",
  "member_charged_to_account": "Caricato in conto",
  "member_unable_to_load_open_match_details_right_now": "Non è possibile caricare i dettagli delle partite aperte in questo momento.",
  "member_unable_to_update_join_request": "Non è possibile aggiornare unisciti alla richiesta.",
  "member_request_approved": "Richiesta approvata.",
  "member_request_rejected": "Richiesta respinta.",
  "member_unable_to_load_this_course_right_now": "Incapace di caricare questo corso in questo momento.",
  "member_unable_to_load_tee_times_right_now": "Incapace di caricare i tempi dei tee in questo momento.",
  "member_course_not_found_or_inactive": "Corso non trovato o inattivo.",
  "member_you_already_joined_this_open_group": "Ti sei già unito a questo gruppo aperto.",
  "member_this_open_group_is_full": "Questo gruppo aperto e' pieno.",
  "member_this_booking_is_no_longer_open_for_joins": "Questa prenotazione non è più aperta per unisciti.",
  "member_this_booking_is_no_longer_available": "Questa prenotazione non è più disponibile.",
  "member_we_could_not_find_your_member_profile_for_this_club": "Non siamo riusciti a trovare il tuo profilo per questo club.",
  "member_you_are_not_eligible_to_join_this_open_group": "Non è possibile aderire a questo gruppo aperto.",
  "member_member_name_required": "Nome utente richiesto",
  "member_guests_are_not_allowed_for_this_course_please_select_a_member": "Gli ospiti non sono ammessi per questo corso. Selezionare un socio.",
  "member_select_a_member_from_the_list": "Selezionare un socio dall'elenco",
  "member_guest_full_name_email_and_phone_are_required": "Ospite nome completo, e-mail e telefono sono richiesti",
  "member_we_could_not_complete_the_booking_please_try_again": "Non abbiamo potuto completare la prenotazione.",
  "member_primary_member_required": "socio primario richiesto",
  "member_guests_are_not_allowed_on_this_court": "Gli ospiti non sono ammessi su questa corte",
  "member_guest_email_and_phone_are_required": "E-mail e telefono ospiti sono richiesti",
  "member_available_tee_times": "Tempi disponibili",
  "member_select_a_course": "Seleziona un corso",
  "member_back_to_courses": "Torna ai corsi",
  "member_choose_your_service": "Scegli il tuo servizio",
  "member_book_a_class": "Prenota una classe",
  "member_that_court_has_just_been_taken_choose_another_available_time": "Quel campo e' appena stato preso, scegli un altro tempo disponibile.",
  "member_payment_could_not_be_completed_your_court_has_not_been_booked": "Il pagamento non può essere completato, il vostro campo non è stato prenotato.",
  "member_we_couldn_t_complete_your_booking_your_court_has_not_been_booked_or_charged": "Non abbiamo potuto completare la vostra prenotazione. La vostra corte non è stata prenotata o addebitata.",
  "member_we_couldn_t_complete_your_booking_please_try_again": "Non siamo riusciti a completare la vostra prenotazione.",
  "member_unable_to_load_course_rates_right_now": "Incapace di caricare i tassi di corso in questo momento.",
  "member_unable_to_load_courses_right_now": "Incapace di caricare i corsi in questo momento.",
  "member_home": "Casa",
  "member_dining": "Ceneri",
  "member_profile": "Profilo",
  "member_member": "Socio",
  "member_dashboard": "Pannello di controllo",
  "member_club": "Club Club",
  "member_select_date": "Seleziona la data",
  "member__count_holes": "{count} buchi",
  "member_player_caption": "Giocatore",
  "member_players_caption": "Giocatori",
  "member_guests": "ospiti",
  "member_joined": "Abbonato",
  "member_friendly": "Amichevole",
  "member_notification": "Notifica",
  "member_please_try_again": "Riprova.",
  "member_notifications": "Notifica",
  "member_loading": "Caricamento…",
  "member_refresh": "Aggiorna",
  "member_clear_all": "Cancella tutto",
  "member_activities": "Attività",
  "member_academy": "Accademia",
  "member_reciprocal_clubs": "Club cinematografici",
  "member_accommodations": "Strutture ricettive",
  "member_voting": "Votazione",
  "member_review": "Recensione",
  "member_dates": "Date",
  "member_occupancy": "Occupazione",
  "member_room": "Camera",
  "member_room_type": "Tipo di camera",
  "member_select_dates": "Seleziona le date",
  "member_total": "Totale",
  "member_from": "Da",
  "member_view_details": "Visualizza dettagli",
  "member_check_in": "Prego, check-in",
  "member_check_out": "Check-out",
  "member_rooms_caption": "Camere",
  "member_close": "Chiudi",
  "member_room_details": "Dettagli dell'alloggio",
  "member_cancel": "Annulla",
  "member_no_upcoming_sessions": "Nessuna sessione imminente",
  "member_activity": "Attività",
  "member_full": "Pieno",
  "member_unable_to_load_activity": "Incapace di caricare l'attività.",
  "member_waitlisted": "In lista di attesa",
  "member_available": "disponibile",
  "member_capacity_count": "Capacità: {count}",
  "member_current_balance": "Saldo attuale",
  "member_contact_front_desk": "Contatta la reception",
  "member_golf_booking_caption": "Golf Prenotazione",
  "member_reservation": "Prenotazione",
  "member_open": "aperto",
  "member_pdf_announcement": "PDF annuncio",
  "member_tee_time": "Orario di partenza",
  "member_this_booking_has_already_been_cancelled": "Questa prenotazione è già stata cancellata.",
  "member_golf_course": "Campo da golf",
  "member_booked": "prenotato",
  "member_date": "Data",
  "member_holes_caption": "Buche",
  "member_add_ons": "Extra",
  "member_qty": "Q",
  "member_deadline": "Scadenza:",
  "member_racquet_booking_caption": "Prenotazione racchetta",
  "member_spa_booking": "Prenotazione di Spa",
  "member_spa": "Centro benessere",
  "member_service": "Servizio",
  "member_spa_service": "Trattamento spa",
  "member_fitness_class_caption": "Classe di fitness",
  "member_fitness": "Fitness",
  "member_hotel_rooms": "Hotel / Camere",
  "member_accommodation": "Alloggio",
  "member_dining_area": "Zona pranzo",
  "member_party_size": "Dimensione del partito",
  "member_cost": "Costo",
  "member_status": "Stato",
  "member_good_morning": "Buongiorno.",
  "member_view_all": "Vedi tutto",
  "member_club_news": "Notizie dal club",
  "member_retry": "Riprova",
  "member_member_portal_entry_notification": "Notifica di ingresso del Portale",
  "member_of": "di",
  "member_loading_reservation_details": "Caricamento dei dettagli della prenotazione...",
  "member_complimentary": "Complimenti",
  "member_unable_to_load_events": "Incapace di caricare eventi",
  "member_upcoming_caption": "Prossimo",
  "member_past_events": "Eventi passati",
  "member_event": "Evento",
  "member_reserved": "Riservato",
  "member_reserve": "Riserva",
  "member_add_guest": "Aggiungere gli ospiti",
  "member_first_name": "Nome",
  "member_last_name": "Cognome",
  "member_email": "E-mail",
  "member_phone": "Telefono",
  "member_dietary": "Aliquote",
  "member_notes": "Note",
  "member_guest": "Ospite",
  "member_try_again": "Riprova",
  "member_member_price": "Prezzo unitario",
  "member_continue": "Continua",
  "member_classes": "Lezioni",
  "member_coach": "Allenatore",
  "member_golf": "Golf",
  "member_loading_tee_times": "Caricamento dei tempi...",
  "member_golf_tee_times": "Orari di partenza golf",
  "member_select": "Seleziona",
  "member_unable_to_load": "Incapace di caricare",
  "member_back": "Indietro",
  "member_min": "min min min",
  "member_booking_type": "Tipo di prenotazione",
  "member_add_player": "Aggiungi il giocatore",
  "member_guest_name": "Nome ospite",
  "member_no_booking_durations_are_configured_for_this_court": "Nessuna durata di prenotazione è configurata per questo campo.",
  "member_racquet": "Racchetta",
  "member_duration": "Durata",
  "member_select_duration": "Selezionare la durata",
  "member_select_booking_type": "Selezionare il tipo di prenotazione",
  "member_remove": "Rimuovi",
  "member_name": "Nome",
  "member_guest_phone": "Telefono degli ospiti",
  "member_confirmed": "confermato",
  "member_pending_requests": "Richieste di pagamento",
  "member_none": "Nessuno",
  "member_reject": "Rifiuti",
  "member_approve": "Approvo",
  "member_loading_courts": "Corti di carico...",
  "member_show_less": "Mostra di meno",
  "member_availability": "Disponibilità",
  "member_unavailable": "Non disponibile",
  "member_awaiting_approval": "Approvazione in attesa",
  "member_checkout": "Pagamento",
  "member_grid": "Griglia",
  "member_list": "Elenco",
  "member_reciprocal_club_caption": "Club Reciproco",
  "member_more": "di più",
  "member__count_left": "{count} sinistra",
  "member_limited_availability": "Disponibilità limitata",
  "member_creating_match": "Creare un match...",
  "member_reserving_court": "Il campo di riserva...",
  "member_manage_activities": "Gestisci le attività",
  "member_you_are_not_assigned_to_any_activities": "Non sei assegnato a nessuna attività.",
  "member_managed_activity": "Attività gestite",
  "member_manage_sessions": "Gestione delle sessioni",
  "member_unable_to_load_sessions": "Incapace di caricare le sessioni.",
  "member_unable_to_update_session": "Non è possibile aggiornare la sessione.",
  "member_you_do_not_have_access_to_this_activity": "Non hai accesso a questa attività.",
  "member_viewing_roster": "Visualizza roster",
  "member_plan_your_next_experience_with_precision_and_ease": "Pianifica la tua prossima esperienza con precisione e facilità.",
  "member_add_a_concierge_note": "Aggiungi una nota di concierge",
  "member_decrease_adults_for_room_room": "Diminuire gli adulti per la stanza {room}",
  "member_increase_adults_for_room_room": "Aumentare gli adulti per camera {room}",
  "member_decrease_children_for_room_room": "Diminuire i bambini per la stanza {room}",
  "member_increase_children_for_room_room": "Aumentare i bambini per la stanza {room}",
  "member__holes_hole_pricing": "{holes} -hole pricing",
  "member_pay_amount": "Pagamenti {amount}",
  "member_guest_count": "Ospite # {count}",
  "member_member_count": "Iscritto{count}",
  "member_calculating": "Calcolo...",
  "member_choose_duration_for_name": "Scegliere la durata per {name}",
  "member_book_sport": "Prenota {sport}",
  "member_see_all_count": "Vedi tutti i {count}",
  "member_view_roster": "Visualizza roster",
  "member_unable_to_load_roster": "Incapace di caricare roster.",
  "member_unable_to_create_session": "Incapace di creare una sessione.",
  "member_sessions_caption": "Sessioni",
  "member_add_session": "Aggiungi sessione",
  "member_no_sessions_yet": "Non ci sono ancora sessioni.",
  "member_cancelled": "Annullato",
  "member_active": "Attivo",
  "member_capacity": "Capacità",
  "member_roster": "Turni del personale",
  "member_clear": "Cancella",
  "member_loading_roster": "Caricamento roster...",
  "member_no_bookings_yet": "Ancora nessuna prenotazione.",
  "member_member_caption": "Socio",
  "member_select_a_session_to_view_the_roster": "Selezionare una sessione per visualizzare il roster.",
  "member_start_time": "Tempo di inizio",
  "member_select_time": "Selezionare il tempo",
  "member_end_time": "Tempo di chiusura",
  "member_optional": "Facoltativo",
  "member_processing_payment": "Elaborazione di pagamento...",
  "member_remove_name": "Rimuovi {name}",
  "member_pending": "In attesa",
  "member_paid": "Pagato",
  "member_completed": "Completato",
  "member_no_show": "Mancata presentazione",
  "member_refunded": "Rimborsato",
  "member_failed": "Non riuscito",
  "member_expired": "Scadenza",
  "member_held": "Tenuto",
  "member_status_unavailable": "Stato non disponibile",
  "member_booking": "Prenotazione...",
  "member_requesting": "Richiesta...",
  "member_joining": "Unisciti...",
  "member_guest_full_name": "Nome completo degli ospiti",
  "member_book_tee_time": "Prenota ora",
  "member_booking_image_unavailable": "Prenotazione immagine non disponibile",
  "member_expected_refund_amount": "Rimborso previsto: {amount}",
  "member_expected_refund_amount_cancellation_fee_fee": "Rimborso previsto: {amount}; canone di cancellazione {fee}",
  "member__minutes_minutes_price": "{minutes} minuti {price}",
  "member_open_type_match_at_time_on_court_count_places_left": "Open {type} match a {time} su {court} , {count} posti sinistra",
  "member_reciprocal_access": "Accesso reciproco",
  "member_booking_cancelled": "Prenotazione cancellata",
  "member_visit_request_approved": "Richiesta di visita approvata",
  "member_scheduled_class": "Classe programmata",
  "member_places_available_count": "Posti disponibili: {count}",
  "member_primary_member": "socio primario",
  "member_hotel_reservation": "Prenotazione alberghiera",
  "member__sport_open_match": "{sport} · partita aperta",
  "member_facility_unavailable": "Facilità non disponibile",
  "member_book_tee_times": "Prenotare orari di partenza",
  "member_reserve_courts": "Corti di riserva",
  "member_book_spa_services": "Servizi di ristorazione",
  "member_book_fitness_classes": "Lezioni di fitness del libro",
  "member_booking_coming_soon": "Prenotazione in arrivo",
  "member_opening_secure_checkout": "Apertura di check-out sicuro",
  "member_please_wait_while_we_prepare_your_payment": "Vi preghiamo di aspettare mentre prepariamo il vostro pagamento.",
  "member_connecting_to_secure_checkout": "Collegamento per il checkout sicuro...",
  "member_your_member_portal_tab_will_stay_open": "La scheda del portale dei soci resterà aperta.",
  "member_payment_received": "Pagamento ricevuto",
  "member_thank_you_your_payment_is_processing": "Grazie — il pagamento è l'elaborazione.",
  "member_your_secure_checkout_has_completed_we_ll_update_your_account_as_soon_as_the_club_s_payment_confirmation_is_received": "Il tuo checkout sicuro è stato completato. Provvederemo ad aggiornare il tuo account non appena la conferma di pagamento del club viene ricevuta.",
  "member_no_payment_was_taken": "Nessun pagamento è stato preso.",
  "member_you_can_return_to_your_account_and_start_secure_checkout_again_whenever_you_are_ready": "Puoi tornare sul tuo account e ricominciare il checkout sicuro ogni volta che sei pronto.",
  "member_payment_declined": "Pagamento declinato",
  "member_your_payment_could_not_be_completed": "Il pagamento non potrebbe essere completato.",
  "member_checkout_normally_shows_card_decline_messages_before_redirecting_this_page_is_here_if_the_club_sends_you_a_manual_declined_payment_link": "Il checkout mostra normalmente i messaggi card-decline prima di reindirizzare. Questa pagina è qui se il club ti invia un link di pagamento rifiutato manuale.",
  "member_secure_checkout_completed_in_stripe": "Checkout sicuro completato in Stripe .",
  "member_return_to_account": "Ritorno al conto",
  "member_returning_you_to_your_booking": "Tornando alla tua prenotazione...",
  "member_your_booking_is_confirmed_you_can_close_this_checkout_tab_and_continue_in_your_original_booking_tab": "La prenotazione è confermata. È possibile chiudere questa scheda di checkout e continuare nella scheda di prenotazione originale.",
  "member_return_to_booking_confirmation": "Ritorno alla conferma della prenotazione",
  "member_we_could_not_confirm_your_booking": "Non potevamo confermare la prenotazione",
  "member_payment_was_received_but_we_could_not_confirm_the_booking_automatically_please_contact_the_club": "Il pagamento è stato ricevuto, ma non potevamo confermare la prenotazione automaticamente. Si prega di contattare il club.",
  "member_payment_was_received_but_the_booking_could_not_be_finalised_automatically_please_contact_the_club": "Il pagamento è stato ricevuto, ma la prenotazione non potrebbe essere finalizzata automaticamente. Si prega di contattare il club.",
  "member_still_confirming_your_payment_this_may_take_a_few_moments": "Ancora confermando il pagamento, potrebbe volerci qualche istante.",
  "member_confirming_your_payment": "Confermare il pagamento...",
  "member_loading_secure_payment_link": "Caricamento sicuro collegamento di pagamento...",
  "member_payment_link_unavailable": "Collegamento di pagamento non disponibile",
  "member_this_guest_payment_token_is_invalid_or_expired": "Questo token di pagamento per gli ospiti è invalido o scaduto.",
  "member_privana_guest_payment": "Pagamento ospite Privana",
  "member_event_guest_ticket": "Biglietto per gli ospiti",
  "member_date_time_tbc": "Data/ora TBC",
  "member_paid_online_thank_you": "Ho pagato online, grazie.",
  "member_pay_securely_with_privana_pay": "Paga in modo sicuro con Privana Pay",
  "member_your_payment_succeeded_we_are_finalising_your_booking_now": "Il vostro pagamento è riuscito. Stiamo finalizzando la vostra prenotazione ora."
}
